import { getBoardEffectTotal } from './chainReaction';
import { getBoardRelaunchRequest } from './powerUp';

// Board shields protect this throw's retaliation, including the Core's turn.
// Landing indices can remain in saved results, so only show unspent protection.
export const getPlayerShield = (game) => {
  if (
    ![
      'rolled',
      'guardianRolled',
      'minibossRolled',
      'bossPlayerRolled',
      'bossRolled',
    ].includes(game.phase) ||
    !Number.isInteger(game.landingIndex) ||
    getBoardRelaunchRequest(game) ||
    game.bossRoundState?.counterImpactApplied
  )
    return 0;
  return Math.max(0, getBoardEffectTotal(game, 'shield'));
};
